const spinner = {
  name: 'spinner',
  viewBox: '0 0 32 32',
  paths: [
    {
      d: 'M16 0.762v0c0.727 0 1.317 0.59 1.317 1.317v5.082c0 0.727-0.59 1.317-1.317 1.317v0c-0.727 0-1.317-0.59-1.317-1.317v-5.082c0-0.727 0.59-1.317 1.317-1.317z'
    },
    {
      d: 'M25.674 4.372v0c0.561 0.483 0.635 1.325 0.166 1.898l-3.151 3.851c-0.454 0.555-1.272 0.637-1.827 0.182-0.008-0.007-0.016-0.014-0.024-0.021v0c-0.561-0.483-0.635-1.325-0.166-1.898l3.151-3.851c0.454-0.555 1.272-0.637 1.827-0.183 0.008 0.007 0.016 0.014 0.024 0.021z'
    },
    {
      d: 'M30.821 13.513v0c0.127 0.736-0.364 1.437-1.099 1.57l-4.755 0.86c-0.727 0.131-1.423-0.351-1.554-1.078-0.001-0.004-0.001-0.008-0.002-0.011v0c-0.127-0.736 0.364-1.437 1.099-1.57l4.755-0.86c0.727-0.131 1.423 0.351 1.554 1.078 0.001 0.004 0.001 0.008 0.002 0.011z'
    },
    {
      d: 'M29.034 23.908v0c-0.356 0.632-1.157 0.856-1.789 0.5-0.008-0.005-0.016-0.009-0.025-0.014l-4.207-2.491c-0.642-0.38-0.862-1.203-0.496-1.853v0c0.356-0.632 1.157-0.856 1.789-0.5 0.008 0.005 0.016 0.009 0.025 0.014l4.207 2.491c0.642 0.38 0.862 1.203 0.496 1.853z'
    },
    {
      d: 'M21.147 30.693v0c-0.673 0.251-1.421-0.091-1.672-0.763-0.002-0.007-0.005-0.013-0.007-0.020l-1.69-4.761c-0.245-0.691 0.109-1.45 0.796-1.707v0c0.673-0.251 1.421 0.091 1.672 0.763 0.002 0.007 0.005 0.013 0.007 0.020l1.69 4.761c0.245 0.691-0.109 1.45-0.796 1.707z'
    },
    {
      d: 'M10.853 30.693v0c-0.687-0.256-1.041-1.016-0.796-1.707l1.69-4.761c0.24-0.676 0.983-1.030 1.66-0.79 0.007 0.002 0.013 0.005 0.020 0.007v0c0.687 0.256 1.041 1.016 0.796 1.707l-1.69 4.761c-0.24 0.676-0.983 1.030-1.66 0.79-0.007-0.002-0.013-0.005-0.020-0.007z'
    },
    {
      d: 'M2.966 23.908v0c-0.366-0.65-0.145-1.473 0.496-1.853l4.207-2.491c0.624-0.369 1.43-0.163 1.799 0.461 0.005 0.008 0.010 0.016 0.014 0.025v0c0.366 0.65 0.145 1.473-0.496 1.853l-4.207 2.491c-0.624 0.369-1.43 0.163-1.799-0.461-0.005-0.008-0.010-0.016-0.014-0.025z'
    },
    {
      d: 'M1.179 13.513v0c0.125-0.728 0.817-1.217 1.545-1.092 0.004 0.001 0.007 0.001 0.011 0.002l4.755 0.86c0.735 0.133 1.226 0.834 1.099 1.57v0c-0.125 0.728-0.817 1.217-1.545 1.092-0.004-0.001-0.008-0.001-0.011-0.002l-4.755-0.86c-0.735-0.133-1.226-0.834-1.099-1.57z'
    },
    {
      d: 'M6.326 4.372v0c0.544-0.468 1.363-0.406 1.831 0.137 0.007 0.008 0.014 0.016 0.021 0.024l3.151 3.851c0.469 0.573 0.395 1.415-0.166 1.898v0c-0.544 0.468-1.363 0.406-1.831-0.137-0.007-0.008-0.014-0.016-0.021-0.024l-3.151-3.851c-0.469-0.573-0.395-1.415 0.166-1.898z'
    }
  ]
};

export default spinner;
